// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"7540356f","200":"e8efc9a6","207":"11008e4b","239":"ed98b9d9","376":"95f3acde","394":"a6691019","416":"60c1af5f","453":"72f42e35","489":"e7eb5aa7","688":"1350fe2d","888":"3ae5ee45","908":"d1e3d241","950":"055568d8"}[chunkId] + ".chunk.js";
};